/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10.0007" r="6.66667" fill="#01C44F" />
    <path
      d="M10 17.5C5.85775 17.5 2.5 14.1422 2.5 10C2.5 5.85775 5.85775 2.5 10 2.5C14.1422 2.5 17.5 5.85775 17.5 10C17.5 14.1422 14.1422 17.5 10 17.5Z"
      fill="#01C44F"
    />
    <path
      d="M12.5624 8C12.4463 8 12.335 8.04786 12.2529 8.13306C12.1708 8.21826 12.1247 8.33382 12.1247 8.45431V10.2715C12.1247 10.392 12.0786 10.5076 11.9965 10.5928C11.9145 10.678 11.8032 10.7258 11.6871 10.7258H7.49016L8.05909 10.1398C8.14149 10.0542 8.18779 9.93821 8.18779 9.81722C8.18779 9.69624 8.14149 9.58021 8.05909 9.49467C7.97668 9.40912 7.86491 9.36106 7.74836 9.36106C7.63182 9.36106 7.52005 9.40912 7.43764 9.49467L6.12473 10.8576C6.08489 10.9008 6.05366 10.9517 6.03283 11.0075C5.98906 11.1181 5.98906 11.2422 6.03283 11.3528C6.05366 11.4085 6.08489 11.4595 6.12473 11.5027L7.43764 12.8656C7.47833 12.9082 7.52673 12.942 7.58006 12.9651C7.63339 12.9881 7.69059 13 7.74836 13C7.80614 13 7.86334 12.9881 7.91667 12.9651C7.97 12.942 8.0184 12.9082 8.05909 12.8656C8.1001 12.8234 8.13266 12.7731 8.15488 12.7178C8.1771 12.6624 8.18854 12.603 8.18854 12.5431C8.18854 12.4831 8.1771 12.4237 8.15488 12.3683C8.13266 12.313 8.1001 12.2627 8.05909 12.2205L7.49016 11.6344H11.6871C12.0353 11.6344 12.3692 11.4909 12.6155 11.2353C12.8617 10.9797 13 10.633 13 10.2715V8.45431C13 8.33382 12.9539 8.21826 12.8718 8.13306C12.7897 8.04786 12.6784 8 12.5624 8Z"
      fill="white"
    />
  </svg>
);

const KeepItIcon = (props) => <Icon component={svg} {...props} />;

export default KeepItIcon;
